import { PropertyValueSet } from "@genesys/property";
import {
  SettingsCollection,
  createCaseOverridesFromCalcInput,
  BinDataType
} from "../../../tools";
import { TopLevelOverrides } from "../../";
import * as KnownProperties from "../../../tools/known-properties";
import * as GraphQLTypes from "../../../../graphql-types";
import * as OperationTime from "@genesys/client-core/lib/operation-time-dialog";

export function getInputsFromMoistureLoadItem(
  moistureLoadItem: GraphQLTypes.MoistureLoadItemType,
  allProperties: Array<string>,
  topLevelProperties: ReadonlyArray<string>,
  topLevelCaseOverrideProperties: ReadonlyArray<TopLevelOverrides>
): SettingsCollection {
  const moistureloadInput = moistureLoadItem.calculationSettings!;

  const climateData = PropertyValueSet.fromString(
    moistureloadInput.climateSettings
  );

  const moistureLoadSettings = PropertyValueSet.keepProperties(
    topLevelProperties,
    PropertyValueSet.fromString(moistureloadInput.moistureLoadSettings)
  );

  const binSettings = PropertyValueSet.fromString(
    moistureloadInput.binSettings
  );

  const binSize = PropertyValueSet.getInteger(
    KnownProperties.binSize,
    binSettings
  );
  const coolingDataType = PropertyValueSet.getText(
    KnownProperties.climateCoolingDataType,
    binSettings
  )!;
  const binLocationId = PropertyValueSet.getText(
    KnownProperties.binDataLocationId,
    binSettings
  )!;

  const binData = {
    binSize: binSize as 1 | 2 | 5,
    dataType: coolingDataType as BinDataType,
    locationId: binLocationId
  };

  const topLevelCaseOverridePropertiesToKeep =
    topLevelCaseOverrideProperties.flatMap(x => {
      const isOverriden =
        PropertyValueSet.getInteger(x.useProperty, moistureLoadSettings) === 1;
      return isOverriden ? x.overridableProperties : [];
    });

  const mainCaseOverrides = createCaseOverridesFromCalcInput(
    moistureloadInput.caseSettingsOverrides,
    topLevelCaseOverridePropertiesToKeep
  );

  const systemOperationTime = OperationTime.fromPropertyValueSet(
    PropertyValueSet.fromString(moistureloadInput.systemOperationTime || "")
  );

  return {
    climateData,
    moistureLoadSettings,
    binData,
    mainSettingsOverrides: mainCaseOverrides,
    systemOperationTime,
    loadSettings: moistureloadInput.loadCalculationSettings.map((x, index) => ({
      id: x.id,
      loadType: x.loadType,
      name: x.name,
      sortNo: index, // TODO: x.sortNo,
      settings: PropertyValueSet.fromString(x.settings),
      operationTime: OperationTime.fromPropertyValueSet(
        PropertyValueSet.fromString(x.operationTime)
      ),
      caseOverrides: createCaseOverridesFromCalcInput(
        x.loadSettingsOverrides,
        allProperties
      )
    }))
  };
}
